export default function Differentiation() {
  const differentiators = [
    'Executive-level strategic thinking',
    'Compliance-aware system design',
    'No hype. No overcomplication.',
    'Built for long-term scalability',
    'Clarity over complexity',
    'Risk-aware implementation'
  ];

  return (
    <section id="differentiation" className="py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="grid grid-cols-2 gap-0 items-center">
          <div 
            className="relative h-full min-h-[600px] rounded-3xl overflow-hidden"
            style={{
              backgroundImage: 'url(https://public.readdy.ai/ai/img_res/8aa71894dbef77aa5563a80cae3fe7f3.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className="absolute inset-0 bg-blue-600/40"></div>
          </div>

          <div className="pl-20 py-16">
            <h2 className="text-5xl font-semibold text-slate-900 mb-12">
              Why NorthStar Innovations AI
            </h2>

            <div className="space-y-7">
              {differentiators.map((item, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <p className="text-lg font-medium text-slate-900">{item}</p>
                </div>
              ))}
            </div>

            <div className="mt-16 bg-sky-50 rounded-2xl p-8">
              <p className="text-base italic text-slate-700 leading-relaxed mb-4">
                "NorthStar helped us navigate AI implementation with clarity and confidence. Their strategic approach transformed our operations without the typical complexity."
              </p>
              <p className="text-sm font-medium text-slate-900">
                — Healthcare Operations Director
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
